// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lJ-Y","title":"styles_title__yivic"};